import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        module: '.rfct-image-slider',
        slideContainerNav: '.rfct-image-slider__slide-container',
        slide: '.rfct-image-slider__slide',
        slideContainer: '.rfct-image-slider__carousel',
    },
    sliderNavConfig: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        centerMode: false,
        lazyLoad: 'ondemand',
        infinite: true,
        focusOnSelect: true,
        asNavFor: '.rfct-image-slider__carousel',
        prevArrow: '',
        clickable: false,
        nextArrow: '<button class="rfct-button__next rfct-button__next--mobile rfct-button rfct-button--secondary rfct-button--mini"><span class="rfct-button__inner"><span class="rfct-button__icon material-icons">chevron_right</span></span></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: false,
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: false,
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                    dots: false,
                    arrows: true,
                },
            },
        ],
    },
    sliderConfig: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.rfct-image-slider__slide-container',
        draggable: false,
        lazyLoad: 'progressive',
    },
};

export default class ImageSlider {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = this._getDomElements();
        this._isMac = false;
    }

    _getDomElements() {
        return {
            $slideContainerNav: this._$rootElement.find(config.selectors.slideContainerNav),
            $slideContainer: this._$rootElement.find(config.selectors.slideContainer),
        };
    }
    _detectIsMac() {
        //Proof if we are on Apple product
        if (navigator.userAgentData) {
            return navigator.userAgentData.platform === "macOS";
        } else {
            return /Macintosh|MacIntel|MacPPC|Mac68K|iPhone|iPad|iPod/.test(navigator.userAgent);
        }
    }


    init() {
        this._isMac = this._detectIsMac();

        $('#image-gallery').children('.product-details__skeleton').hide();
        $('#image-gallery').children('.rfct-image-slider').show();

        const target = document.querySelector('.rfct-image-slider__slide-container');
   if (!target) return;
        if (!$(target).hasClass('swiper')) {
            this._elements.$slideContainerNav.slick(config.sliderNavConfig);
            this._elements.$slideContainer.slick(config.sliderConfig);
        } else {
            let slidecount = target.querySelectorAll('.swiper-slide');
            if (!target) return;
            const button = document.createElement('button');
            button.className = 'rfct-button__next rfct-button__next--mobile rfct-button rfct-button--secondary rfct-button--mini';

            button.innerHTML = `
            <span class="rfct-button__inner">
            <span class="rfct-button__icon material-icons">chevron_right</span>
            </span>
        `;

            // Thumbnail Slider
            const thumbSwiper = new Swiper('.rfct-image-slider__slide-container', {
                slidesPerView: 2,
                spaceBetween: 30,
                loop: true,
                slideToClickedSlide: false,
                grabCursor: true,
                allowTouchMove: true,
                simulateTouch: true,
                watchSlidesProgress: true,
                centeredSlides: false,
                observer: true,
                observeParents: true,
                lazy: { loadPrevNext: true },
                //   mousewheel: {
                //     forceToAxis: true,
                //     releaseOnEdges: true,
                //     invert: this._isMac,
                //     sensitivity: 1,
                //     eventsTarget: '.rfct-image-slider__slide-container',
                //     passive: true  // <-- wichtig für flüssiges Touchpad
                //   },
                breakpoints: {
                    768: { slidesPerView: 3 },

                }
            });

            // Main Slider
            const mainSwiper = new Swiper('.rfct-image-slider__carousel', {
                slidesPerView: 1,
                loop: true,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                thumbs: { swiper: thumbSwiper },
                navigation: {
                    nextEl: '.rfct-button__next'
                },
                allowTouchMove: false,
                lazy: { loadPrevNext: true }
            });
            if (slidecount.length > 3) {
                target.appendChild(button);
                button.addEventListener('click', () => {
                    mainSwiper.slideNext(400);
                    const newIndex = mainSwiper.realIndex;
                    thumbSwiper.slideToLoop(newIndex, 400);
                });

            };





            thumbSwiper.on('tap', () => {
                const slide = thumbSwiper.clickedSlide;
                if (!slide) return;
                const realIndex = parseInt(slide.getAttribute('data-swiper-slide-index'));
                mainSwiper.slideToLoop(realIndex, 400);
            });
        }


    }


}

moduleRegistry.registerModule('ImageSlider', ImageSlider);
moduleRegistry.autoApplyModule('ImageSlider', config.selectors.module);
